module.exports = __webpack_public_path__ + "static/abhay-resume-c661f64e4b68f3c0ccd94d720e545d5e.pdf";